// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3L4ls","inputDescription":"styles_inputDescription__1yuSo"};